import { render, staticRenderFns } from "./FeedUserProfileEntry.vue?vue&type=template&id=979c2604&scoped=true&"
import script from "./FeedUserProfileEntry.vue?vue&type=script&lang=ts&"
export * from "./FeedUserProfileEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FeedUserProfileEntry.vue?vue&type=style&index=0&id=979c2604&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979c2604",
  null
  
)

export default component.exports